/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { VerificationFieldMappingCommandV1 } from '../models/verification-field-mapping-command-v-1';
import { VerificationFieldMappingV1 } from '../models/verification-field-mapping-v-1';


/**
 * Verification type and field mapping config
 */
@Injectable({
  providedIn: 'root',
})
export class VerificationSupportV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation upsertVerificationFieldMappingV1
   */
  static readonly UpsertVerificationFieldMappingV1Path = '/v1/verifications/mapping/{type}';

  /**
   * Create or update verification field mapping for a type.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertVerificationFieldMappingV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertVerificationFieldMappingV1$Response(params: {
    type: 'TIN' | 'IBAN' | 'GLOBAL_TIN' | 'BANK' | 'GST' | 'EMAIL_DOMAIN' | 'AML_SCREENING' | 'ADVERSE_MEDIA' | 'GLOBAL_KYB' | 'EU_VAT';
    body: VerificationFieldMappingCommandV1
  },
  context?: HttpContext

): Observable<StrictHttpResponse<VerificationFieldMappingV1>> {

    const rb = new RequestBuilder(this.rootUrl, VerificationSupportV1Service.UpsertVerificationFieldMappingV1Path, 'put');
    if (params) {
      rb.path('type', params.type, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VerificationFieldMappingV1>;
      })
    );
  }

  /**
   * Create or update verification field mapping for a type.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertVerificationFieldMappingV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertVerificationFieldMappingV1(params: {
    type: 'TIN' | 'IBAN' | 'GLOBAL_TIN' | 'BANK' | 'GST' | 'EMAIL_DOMAIN' | 'AML_SCREENING' | 'ADVERSE_MEDIA' | 'GLOBAL_KYB' | 'EU_VAT';
    body: VerificationFieldMappingCommandV1
  },
  context?: HttpContext

): Observable<VerificationFieldMappingV1> {

    return this.upsertVerificationFieldMappingV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<VerificationFieldMappingV1>) => r.body as VerificationFieldMappingV1)
    );
  }

  /**
   * Path part for operation deleteVerificationFieldMappingV1
   */
  static readonly DeleteVerificationFieldMappingV1Path = '/v1/verifications/mapping/{type}';

  /**
   * Delete stored verification field mapping, resetting the type to baseline.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteVerificationFieldMappingV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVerificationFieldMappingV1$Response(params: {
    type: 'TIN' | 'IBAN' | 'GLOBAL_TIN' | 'BANK' | 'GST' | 'EMAIL_DOMAIN' | 'AML_SCREENING' | 'ADVERSE_MEDIA' | 'GLOBAL_KYB' | 'EU_VAT';
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, VerificationSupportV1Service.DeleteVerificationFieldMappingV1Path, 'delete');
    if (params) {
      rb.path('type', params.type, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete stored verification field mapping, resetting the type to baseline.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteVerificationFieldMappingV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVerificationFieldMappingV1(params: {
    type: 'TIN' | 'IBAN' | 'GLOBAL_TIN' | 'BANK' | 'GST' | 'EMAIL_DOMAIN' | 'AML_SCREENING' | 'ADVERSE_MEDIA' | 'GLOBAL_KYB' | 'EU_VAT';
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteVerificationFieldMappingV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getVerificationFieldMappingsV1
   */
  static readonly GetVerificationFieldMappingsV1Path = '/v1/verifications/mapping';

  /**
   * Get verification types with field mapping config.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVerificationFieldMappingsV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVerificationFieldMappingsV1$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<VerificationFieldMappingV1>>> {

    const rb = new RequestBuilder(this.rootUrl, VerificationSupportV1Service.GetVerificationFieldMappingsV1Path, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<VerificationFieldMappingV1>>;
      })
    );
  }

  /**
   * Get verification types with field mapping config.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVerificationFieldMappingsV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVerificationFieldMappingsV1(params?: {
  },
  context?: HttpContext

): Observable<Array<VerificationFieldMappingV1>> {

    return this.getVerificationFieldMappingsV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<VerificationFieldMappingV1>>) => r.body as Array<VerificationFieldMappingV1>)
    );
  }

}
